
import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Badge } from 'reactstrap';
import 'react-day-picker/lib/style.css';
import { faEye } from '../../node_modules/@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { DateUtils } from "react-day-picker";
// First way to import
import { Redirect } from 'react-router-dom';
import MainLayout from '../layout/layout';
import AuditService from '../Services/auditService/auditService';
import ActionTypes from '../utils/actions';
import RolesType from '../utils/roles';
//import AuthService from '../Services/authService/authService';

class Audit extends Component {
    constructor(props) {
        super();
        this.state = {
            AuditData: { pending: false, value: [] },
            totalCount: 0,
            page: 1,
            maxPerPage: 10,
            Filter: {
                FilterUserName: "",
                FilterCompanyCode: "",
                FilterAction: "",
                FilterStartDate: "",
                FilterEndDate: ""
            },
            modal: false,
            idAudit: null,
            loading: true,
            SelectActions: "",
            ActionsList: [],
            isAutenticated: true
        };
        this.toggle = this.toggle.bind(this);
        this.companyCodeValue = this.companyCodeValue.bind(this);
        this.emailValue = this.emailValue.bind(this);
        this.handleActions = this.handleActions.bind(this);
        this.hanldeKeyPress = this.hanldeKeyPress.bind(this);
    }
    wait = 0;    
    startdate;
    enddate; 

    hanldeKeyPress(e){
        if(e.keyCode === 13){
            this.getAllAuditsWithoutParameters()
         }
    }
    getStartDate(day) {

        var  isDate = DateUtils.isDate(day);

        if(isDate && day)
        {
            if (day) {
                let newstartDate = new Date(day);
                this.startdate = newstartDate.getFullYear() + "-" + (newstartDate.getMonth() + 1) + "-" + newstartDate.getDate();
            }
            else{
                this.startdate = null;
            }
            let stateCopy = Object.assign({}, this.state);
            stateCopy.Filter.FilterStartDate = this.startdate;
            stateCopy.Filter.FilterEndDate = this.enddate;
            this.setState(stateCopy); 
            this.getAllAuditsWithoutParameters();             
        }
     }
     getEndDate(day) {

        var  isDate = DateUtils.isDate(day);

        if(isDate && day)
        {
         
            if (day) {
                let newendDate = new Date(day);
                this.enddate = newendDate.getFullYear() + "-" + (newendDate.getMonth() + 1) + "-" + newendDate.getDate();
            }
            else
            {
                this.enddate = null;                  
            }
            let stateCopy = Object.assign({}, this.state);
            stateCopy.Filter.FilterStartDate = this.startdate;
            stateCopy.Filter.FilterEndDate = this.enddate;
            this.setState(stateCopy);

            this.getAllAuditsWithoutParameters();
        }           
    }
    companyCodeValue(e) {
        e.preventDefault();
              
        let stateCopy = Object.assign({}, this.state);
        stateCopy.Filter.FilterCompanyCode = e.target.value;
        this.setState(stateCopy);
    }
    emailValue(e) {
        e.preventDefault();
              
        let stateCopy = Object.assign({}, this.state);
        stateCopy.Filter.FilterUserName = e.target.value;
        this.setState(stateCopy);
    }
    handleActions(event) {
    
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.SelectActions = value;
        stateCopy.Filter.FilterAction = value;
        this.setState(stateCopy);

         this.getAllAuditsWithoutParameters();
    }
    getAllAction() {
        let dataResult = ActionTypes;
        var temp = Object.keys(dataResult);
        this.setState({
            ActionsList: temp
        });                   
    }
    getAllAuditsWithoutParameters(){

        this.setState({
            AuditData: { pending: true, value: [] },
            totalCount: 0
        });
        var DataResult = AuditService.getAudits(1, 10, this.state.Filter.FilterCompanyCode, this.state.Filter.FilterUserName,
            this.state.Filter.FilterAction, this.state.Filter.FilterStartDate, this.state.Filter.FilterEndDate);

        var that = this;

        DataResult.then(function (data) {

            that.setState({
                AuditData: { pending: false, value: data.data.Audits },
                totalCount: parseInt(data.data.Audit_Total_Count, 10),
                page: data.data.npage
            });
        }).catch((error) => {

            that.setState({
                AuditData: { pending: false, value: [] },
                totalCount: 0
            });  
            if(error.response)
            {
                if(error && error.response && error.response.data.Message === "500") {               
                    toast.error("Error Data Base(Error: 500)", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NoDB") {
                   toast.error("Company Code dosen't exist!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NotReseller") {    
                   toast.error("This User does not have permission!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data.Message === "400"){ 
                   toast.error("API Error for Reseller", { className: {
                       opacity: 0.8
                   }});
                }else if(error.response.status === 401){ 
                       sessionStorage.setItem("user", '');
                       sessionStorage.setItem("token", '');
                       sessionStorage.setItem("rol", '');
                       sessionStorage.setItem("email", '');
                       sessionStorage.clear();  
                       this.setState({ isAutenticated: false },
                       ()=>{                               
                           this.forceUpdate();
                       })              
                }   
            }else{
                toast.error("Code Error", { className: {
                    opacity: 0.8
                }});
            }
        });
    }
    componentDidMount() {

        var DateInicial  = "";
        var DateFinal = "";
        if(this.state.Filter.FilterStartDate === "" && this.state.Filter.FilterEndDate === "")
        {
            var fecha = new Date();
            var otraFecha = fecha.setDate(fecha.getDate() - 7);        
            var date = new Date(otraFecha);
            DateInicial = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();     
            var Final = new Date();
            DateFinal = Final.getFullYear() + "-" + (Final.getMonth() + 1) + "-" + Final.getDate();    
        }else{
            DateInicial = this.state.Filter.FilterStartDate;
            DateFinal = this.state.Filter.FilterEndDate;
        } 
        this.getAllAudits(this.state.page, this.state.maxPerPage, this.state.Filter.FilterCompanyCode, this.state.Filter.FilterUserName,
            this.state.Filter.FilterAction, DateInicial, DateFinal);

        this.getAllAction();   
    }
    getAllAudits(page, maxPerPage, CompanyCode, UserName, Action, StartDate, EndDate) {

        this.setState({
            AuditData: { pending: true, value: [] },
            totalCount: 0
        });
        var DataResult = AuditService.getAudits(page, maxPerPage, CompanyCode, UserName, Action, StartDate, EndDate);
        var that = this;
        DataResult.then(function (data) {
            that.setState({
                AuditData: { pending: false, value: data.data.Audits },
                totalCount: parseInt(data.data.Audit_Total_Count, 10),
                page: data.data.npage,
                Filter: {FilterUserName: UserName, FilterCompanyCode: CompanyCode, FilterAction: Action, FilterStartDate: StartDate, FilterEndDate: EndDate}
            });
        }).catch((error) => {
            that.setState({
                AuditData: { pending: false, value: [] },
                totalCount: 0
            });
            if(error.response)
            {
                if(error && error.response && error.response.data.Message === "500") {               
                    toast.error("Error Data Base(Error: 500)", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NoDB") {
                   toast.error("Company Code dosen't exist!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NotReseller") {    
                   toast.error("This User does not have permission!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data.Message === "400"){ 
                   toast.error("API Error for Reseller", { className: {
                       opacity: 0.8
                   }});
                }else if(error.response.status === 401){ 
                       sessionStorage.setItem("user", '');
                       sessionStorage.setItem("token", '');
                       sessionStorage.setItem("rol", '');
                       sessionStorage.setItem("email", '');
                       sessionStorage.clear();  
                       this.setState({ isAutenticated: false },
                       ()=>{                               
                           this.forceUpdate();
                       })              
                }   
            }else{
                toast.error("Code Error", { className: {
                    opacity: 0.8
                }});
            }
        });
    }
    toggle(e, id) {
        this.setState({
            modal: !this.state.modal,
            idAudit: id
        });
    }
    getAuditByID(id) {
        return this.state.AuditData.pending ? null : this.state.AuditData.value.find(x => x.ID === id);
    }
    truncate(value) {

        if (value)
            var res = value.slice(1, 30);

        return res + "...";
    }
    getPrevPage(currentPage, maxPerPage) {
        if (parseInt(maxPerPage >= this.state.totalCount, 10))
            return 0;
        else
            return currentPage - 1;
    }
    getNextPage(currentPage, maxPerPage) {
        if ( parseInt( this.state.totalCount / maxPerPage, 10) === currentPage && parseInt(this.state.totalCount % maxPerPage, 10) === 0)
            return 0;
        else if ( parseInt(this.state.totalCount / maxPerPage, 10) === currentPage - 1 && parseInt(this.state.totalCount % maxPerPage, 10) > 0)
            return 0;
        else
            return currentPage + 1;
    }
    getPagesCount(maxPerPage) {
        if (parseInt(this.state.totalCount % maxPerPage, 10) > 0)
            return (this.state.totalCount / maxPerPage) + 1;
        else
            return this.state.totalCount / maxPerPage;
    }
    renderPages() {
        
        let pages = [];
        let pagesCount = parseInt(this.getPagesCount(this.state.maxPerPage), 10);
        let pagesShow = pagesCount > 5 ? 5 : this.getPagesCount(this.state.maxPerPage);
        let startPagination = pagesCount <= 5 ? 1 : (this.state.page - 3 <= 0 ? 1 : (this.state.page + 2 > pagesCount ? pagesCount - 4 : this.state.page - 2));
        for (let i = startPagination; i <= startPagination + pagesShow - 1; i++) {
            pages.push(<li key={i} className={this.state.page === i ? "page-item active" : "page-item"} onClick={(event) => {
                event.preventDefault(); this.getAllAudits(i, this.state.maxPerPage, this.state.Filter.FilterCompanyCode, this.state.Filter.FilterUserName,
                    this.state.Filter.FilterAction, this.state.Filter.FilterStartDate, this.state.Filter.FilterEndDate)
            }}><a className="page-link">{i}</a></li>);
        }
        return pages
    }
    renderNextPage() {
        let next_page = this.getNextPage(this.state.page, this.state.maxPerPage);
        let pagesCount = parseInt(this.getPagesCount(this.state.maxPerPage), 10);
        let nextpages = [];
        if (next_page !== 0) {
            nextpages.push(<li key="Next" className="page-item" onClick={(event) => {
                event.preventDefault(); this.getAllAudits(next_page, this.state.maxPerPage, this.state.Filter.FilterCompanyCode, this.state.Filter.FilterUserName,
                    this.state.Filter.FilterAction, this.state.Filter.FilterStartDate, this.state.Filter.FilterEndDate)
            }}>
                <a className="page-link" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                </a>
            </li>);
            nextpages.push(<li key="Last" className="page-item" onClick={(event) => {
                event.preventDefault(); this.getAllAudits(pagesCount, this.state.maxPerPage, this.state.Filter.FilterCompanyCode, this.state.Filter.FilterUserName,
                    this.state.Filter.FilterAction, this.state.Filter.FilterStartDate, this.state.Filter.FilterEndDate)
            }}>
                <a className="page-link" aria-label="Last">
                    <span aria-hidden="true">Last</span>
                </a>
            </li>);
        }
        else {
            nextpages.push(<li key="NextP" className="page-item disabled">
                <a className="page-link" aria-label="Next">
                    <span aria-hidden="true">&raquo;</span>
                </a>
            </li>);
            nextpages.push(<li key="LastP" className="page-item disabled">
                <a className="page-link" aria-label="Last">
                    <span aria-hidden="true">Last</span>
                </a>
            </li>);
        }
        return nextpages;
    }
    renderFirstPage() {
        let prev_page = this.getPrevPage(this.state.page, this.state.maxPerPage);
        let prevpages = [];
        if (prev_page !== 0) {
            prevpages.push(<li key="FirstT" className="page-item" onClick={(event) => {
                event.preventDefault(); this.getAllAudits(1, this.state.maxPerPage, this.state.Filter.FilterCompanyCode, this.state.Filter.FilterUserName,
                    this.state.Filter.FilterAction, this.state.Filter.FilterStartDate, this.state.Filter.FilterEndDate)
            }}>
                <a className="page-link" aria-label="First">
                    <span aria-hidden="true">First</span>
                </a>
            </li>);
            prevpages.push(<li key="FirstTT" className="page-item" onClick={(event) => {
                event.preventDefault(); this.getAllAudits(prev_page, this.state.maxPerPage, this.state.Filter.FilterCompanyCode, this.state.Filter.FilterUserName,
                    this.state.Filter.FilterAction, this.state.Filter.FilterStartDate, this.state.Filter.FilterEndDate)
            }}>
                <a className="page-link" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                </a>
            </li>);
        }
        else {
            prevpages.push(<li key="FirstPP" className="page-item disabled">
                <a className="page-link" aria-label="First">
                    <span aria-hidden="true">First</span>
                </a>
            </li>);
            prevpages.push(<li key="FirstPPP" className="page-item disabled">
                <a className="page-link" aria-label="Previous">
                    <span aria-hidden="true">&laquo;</span>
                </a>
            </li>);
        }
        return prevpages;
    }
    renderAuditRow()
    {        
        let optionItemsActions = this.state.ActionsList.map((item, index) => {  
            return <option key={index} className="dropdown-item" href="#" value={item} >{item}</option>
        });

        let dataResult = RolesType;

        var temp = Object.keys(dataResult);    
        if(sessionStorage.getItem("rol") === temp[0] || sessionStorage.getItem("rol") === temp[1] || sessionStorage.getItem("rol") === temp[5])
        {
            return (<div>
                      <div className="row">
                        <div className="col s12">
                            <div className="card Logs">
                                <div className="card-header">
                                    <div className="row" id="timelogs_filter">
                                        <div className="col-lg-2 col-md-2 col-sm-2">
                                            <label className="control-label" style={{'fontWeight': 'bold'}}>Company Code</label>
                                            <div className="form-group">
                                                <input className="form-control" name="companycode" id="companycode" type="text" onKeyDown={this.hanldeKeyPress} onChange={this.companyCodeValue} value={this.state.Filter.FilterCompanyCode} />
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-3">
                                            <label className="control-label" style={{'fontWeight': 'bold'}}>User(Email)</label>
                                            <div className="form-group">
                                                <input type="text" name="email" id="email" className="form-control" onKeyDown={this.hanldeKeyPress} onChange={this.emailValue} value={this.state.Filter.FilterUserName}/>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-3">
                                            <label className="control-label" style={{'fontWeight': 'bold'}}>Action</label>
                                            <select className="form-control" onChange={this.handleActions} value={this.state.SelectActions}>
                                                <option className="dropdown-item" href="#" value="" >Select</option>
                                                {optionItemsActions}
                                            </select>
                                        </div>
                                        <div className="col-lg-2 col-md-2 col-sm-2">
                                            <label className="control-label" style={{'fontWeight': 'bold'}}>Start Date</label>
                                            <div className="form-group">
                                                <DayPickerInput
                                                    onDayChange={day => this.getStartDate(day)}
                                                    value={this.state.Filter.FilterStartDate}
                                                    format={"YYYY"}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-2 col-sm-2">
                                            <label className="control-label" style={{'fontWeight': 'bold'}}>End Date</label>
                                            <div className="form-group">
                                                <DayPickerInput
                                                    onDayChange={day => this.getEndDate(day)}
                                                    value={this.state.Filter.FilterEndDate }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <table className="table table-hover table-striped table-sm myTable">
                                        <thead>
                                            <tr>
                                                <th scope="col" style={{'fontWeight': 'bold'}}>User</th>
                                                <th scope="col" style={{'fontWeight': 'bold'}}>Action</th>
                                                <th scope="col" style={{'fontWeight': 'bold'}}>Date Action</th>
                                                <th scope="col" style={{'fontWeight': 'bold'}}>Description</th>
                                                <th scope="col" style={{'fontWeight': 'bold'}}>Company Code</th>
                                                <th scope="col" style={{'fontWeight': 'bold'}}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.state.AuditData.pending
                                                    ? <tr><td colSpan="7"><span className="loader"></span></td></tr>
                                                    : this.state.AuditData.value.map((item, index) => {
                                                        return <tr key={index} >
                                                            <td style={{'fontWeight': '400'}}>{item.EMAIL}</td>
                                                            <td style={{'fontWeight': '400'}}>{item.ACTIONS}</td>
                                                            <td style={{'fontWeight': '400'}}>{item.DATEACTION.replace("T", " ")}</td>
                                                            <td style={{'fontWeight': '400'}}>{this.truncate(item.DESCRIPTION)}</td>
                                                            <td style={{'fontWeight': '400'}}>{item.COMPANY_CODE}</td>
                                                            <td>
                                                                {
                                                                    <h6>
                                                                        <a onClick={(e) => this.toggle(e, item.ID)}><Badge color="warning"><FontAwesomeIcon icon={faEye} /></Badge></a>
                                                                    </h6>
                                                                }
                                                            </td>
                                                        </tr>;
                                                    })
                                            }
                                        </tbody>
                                    </table>
                                    <nav aria-label="Page navigation example">
                                        <ul className="pagination">
                                            {this.renderFirstPage()}
                                            {this.renderPages()}
                                            {this.renderNextPage()}
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>);
        }else{
            return (<Redirect to={'/login'}/>)
        }
    }
    render() {

        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'}/>)
        }
        
        return (
            <div>
                <MainLayout /><ToastContainer hideProgressBar/>
                <div className="container">
                   {
                       this.renderAuditRow()
                   }
                    <Modal isOpen={this.state.modal} toggle={this.toggle}
                        aria-labelledby="contained-modal-title-lg"
                        className={"modal-dialog modal-notify modal-info modal-lg"}
                    >
                        <ModalHeader toggle={this.toggle}><p className="heading lead">Details</p></ModalHeader>
                        <ModalBody style={{ 'maxHeight': 'calc(100vh - 250px)', 'overflowY': 'auto' }}>
                            {this.renderDetails()}
                        </ModalBody>
                        <ModalFooter>
                            <a className="btn btn-outline-info waves-effect" onClick={this.toggle}>Close</a>
                        </ModalFooter>
                    </Modal>
                </div>
            </div>
        );
    }
    renderDetails() {

        var element = this.getAuditByID(this.state.idAudit);
        if (!element)
            return null;

        return <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-6">
                            <span style={{'fontWeight': '900'}}><strong>Action:&nbsp;</strong></span>
                            <span id="CompanyCodeEdit" style={{'width':'100%', 'wordWrap': 'break-word', 'fontWeight': '400' }}>{element.ACTIONS}</span>
                        </div>
                        <div className="col-md-6">
                            <span style={{'fontWeight': '900'}}><strong>User:&nbsp;</strong></span>
                            <span id="LogLevelEdit" style={{'width':'100%', 'wordWrap': 'break-word', 'fontWeight': '400' }}>{element.EMAIL}</span>
                        </div>
                    </div> <br />
                    <div className="row">
                        <div className="col-md-6">
                            <span style={{'fontWeight': '900'}}><strong>Create Date:&nbsp;</strong></span>
                            <span id="CreateDateEdit" style={{'width':'100%', 'wordWrap': 'break-word', 'fontWeight': '400' }}>{element.DATEACTION.replace("T", " ")}</span>
                        </div>
                        <div className="col-6 col-md-6">
                            <span style={{'fontWeight': '900'}}><strong>Company Code:&nbsp;</strong></span>
                            <span id="StackTraceEdit" style={{'width':'100%', 'wordWrap': 'break-word', 'fontWeight': '400' }}>{element.COMPANY_CODE}</span>
                        </div>
                    </div><br />
                    <div className="row">
                        <div className="col-md-12">
                            <p style={{'fontWeight': '900'}}><strong>Message:&nbsp;</strong></p>
                            <div id="MessageEdit" style={{'width':'100%', 'wordWrap': 'break-word', 'fontWeight': '400' }}>{element.DESCRIPTION}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}
export default Audit;


// WEBPACK FOOTER //
// ./src/Audit/audit.jsx